import translations from '../../components/location/ts/et-EE';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('et-EE', translations);
